import { createAction } from "redux-actions";
import { SET_PAGE_NAME } from "./constants";

export const setPageName = createAction(SET_PAGE_NAME);
